import React from 'react'
import { css, cx } from '@emotion/css'
import { legacyTheme } from '../legacy-theme'

export const componentDataTestID = 'legacy-grid-cell'

export function Cell({
  Component,
  children,
  isLastColumn = false,
  className
}: {
  readonly Component: 'th' | 'td'
  readonly children: React.ReactNode
  readonly isLastColumn?: boolean
  readonly className?: string
}) {
  return (
    <Component
      data-testid={componentDataTestID}
      className={cx(
        isLastColumn === false
          ? css`
              border-right: 1px solid ${legacyTheme.colors.tableBorder};
            `
          : undefined,
        className
      )}
    >
      {children}
    </Component>
  )
}
